/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable react/jsx-key */
/* eslint-disable no-console */


import React from "react";
import {
  formatter,
  Priceformatter,
  validateData,
} from "../../../constants/CommonMethods";
import { ReactComponent as CloseIcon } from "../../../assets/images/close_icon.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as QRCode } from "../../../assets/images/qr-code-mx.svg";
export default function PrintPackagePrice(props: any) {
  const packageIds = validateData(props.packageIdsToPrint)
    ? props.packageIdsToPrint
    : [];
  console.log("packageIds", packageIds);

  // debugger
  const packageDetails = validateData(props.detailsToPrint)
    ? props.detailsToPrint
    : [];
  console.log("packageDetails", packageDetails);
 

  const PrintPackagePrice = () => {
    console.log("inside print");
    const storeDetails = sessionStorage.getItem("storeDetails") || "";
    if (storeDetails) {
      console.log("store", storeDetails);
    }
    const encodestore = Buffer.from(storeDetails, "base64");
    console.log("encoded", encodestore);
    const decodestore: any = JSON.parse(encodestore.toString("utf-8"));
    const { t } = useTranslation("PriceTag");
    console.log("inside Print Function", props);
    console.log("decodestore", decodestore);
    return packageIds.map((value: any) => {
      console.log("value", value);
      console.log("value", value);
      // debugger
      return packageDetails.map((data: any, index: any) => {
        console.log("data", data);
        const rateRegular = (Number(data.regularWeeklyRate) - Number(data.weeklyRate))?.toFixed(2)
        const regularRate=(((parseFloat(data.regularWeeklyRate))+(parseFloat(data.regularWeeklyRateTaxAmount)))-((parseFloat(data.weeklyRate))+(parseFloat(data.weeklyRateTaxAmount))));
        if (decodestore?.state == "CA" || decodestore?.state == "NY") {
          if (value == data.packagePriceId.toString()) {
            const costRental = Number(data.totalCost) - Number(data.cashPrice);
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "20%",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                        marginBottom: "30px",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <p style={{ fontSize: "24px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </p>
                        );
                      })}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginTop: "10px",
                        whiteSpace: "nowrap",
                        marginBottom: "20px",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        {validateData(data) &&
                        validateData(data.sacDaysToPrint) &&
                        Number(data.sacDaysToPrint) > 0 ? (
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {data.sacDaysToPrint} {t("Days Same as Cash")}
                          </span>
                        ) : (
                          <span style={{ fontSize: "20px" }}></span>
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "7px",
                        padding: "2px 123px",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          border: "2px solid #000",
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody style={{ fontSize: "20px", width: "100%" }}>
                          <tr>
                            <td
                              rowSpan={2}
                              style={{
                                borderRight: "2px solid #000",
                                padding: "8px 11px",
                                textAlign: "center",
                                verticalAlign: "top",
                                width: "25%",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                }}
                              >
                                {t("TOTAL OF")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                }}
                              >
                                {t("PAYMENTS")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "5.5px",
                                  borderBottom: "2px solid black",
                                }}
                              >
                                {" "}
                                {validateData(data) &&
                                validateData(data.totalCost)
                                  ? formatter
                                      .format(data.totalCost)
                                      .replace(/^(\D+)/, "$1 ")
                                  : "-"}
                              </p>
                              <p
                                style={{
                                  marginTop: 0,
                                  marginBottom: 0,
                                  textAlign: "left",
                                  fontSize: "14px",
                                }}
                              >
                                {t(
                                  "You must pay this amount to own the property if you make all regular payments."
                                )}
                              </p>
                              <p
                                style={{
                                  marginTop: 0,
                                  marginBottom: "25px",
                                  textAlign: "left",
                                  fontSize: "14px",
                                }}
                              >
                                {t("(TAX NOT INCLUDED)")}
                              </p>
                              <p
                                style={{
                                  marginTop: 0,
                                  marginBottom: "2px",
                                  textAlign: "left",
                                  fontSize: "14px",
                                }}
                              >
                                {t(
                                  "You can buy the property for less under the early purchase option."
                                )}
                              </p>
                            </td>
                            <td
                              style={{
                                borderRight: "2px solid #000",
                                padding: "8px 11px",
                                textAlign: "center",
                                verticalAlign: "top",
                                width: "25%",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                }}
                              >
                                {t("COST OF")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                }}
                              >
                                {t("RENTAL")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "5.5px",
                                  borderBottom: "2px solid black",
                                }}
                              >
                                {validateData(costRental)
                                  ? formatter
                                      .format(costRental)
                                      .replace(/^(\D+)/, "$1 ")
                                  : "-"}
                              </p>
                              <p
                                style={{
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginTop: 0,
                                }}
                              >
                                {t(
                                  "Amount over cash price you will pay if you make all regular payments.(TAX NOT INCLUDED)"
                                )}
                              </p>
                            </td>
                            <td
                              colSpan={2}
                              style={{
                                borderRight: "2px solid #000",
                                padding: "8px 11px",
                                textAlign: "center",
                                verticalAlign: "top",
                                width: "50%",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                  textAlign: "left",
                                }}
                              >
                                {t("CASH PRICE")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: "26px",
                                  marginBottom: "5.5px",
                                  borderBottom: "2px solid black",
                                  width: "34%",
                                }}
                              >
                                {validateData(data) &&
                                validateData(data.cashPrice)
                                  ? formatter
                                      .format(data.cashPrice)
                                      .replace(/^(\D+)/, "$1 ")
                                  : "-"}
                              </p>
                              <p
                                style={{
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginTop: 0,
                                }}
                              >
                                {t(
                                  "Property available at this price for cash from the lessor. See about your early purchase options rights.(TAX NOT INCLUDED)"
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                borderRight: "2px solid #000",
                                borderTop: "2px solid #000",
                                padding: "8px 11px",
                                textAlign: "center",
                                verticalAlign: "top",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                }}
                              >
                                {t("AMOUNT OF")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "2.5px",
                                }}
                              >
                                {t("EACH PAYMENT")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "5.5px",
                                  borderBottom: "2px solid black",
                                  textAlign: "left",
                                }}
                              >
                                {" "}
                                {validateData(data) &&
                                validateData(data.weeklyRate)
                                  ? formatter
                                      .format(data.weeklyRate)
                                      .replace(/^(\D+)/, "$1 ")
                                  : "-"}{" "}
                              </p>
                              <p
                                style={{
                                  marginTop: 0,
                                  marginBottom: "2px",
                                  fontSize: "14px",
                                }}
                              >
                                {t("(Tax not included)")}
                              </p>
                              <p
                                style={{
                                  marginTop: "0",
                                  marginBottom: "1.5px",
                                  textAlign: "left",
                                  fontSize: "14px",
                                }}
                              >
                                {t("per")}
                                <u style={{ paddingLeft: "22%" }}>
                                  {t("Week")}
                                </u>
                              </p>
                            </td>
                            <td
                              style={{
                                borderRight: "2px solid #000",
                                borderTop: "2px solid #000",
                                padding: "8px 11px",
                                textAlign: "center",
                                verticalAlign: "top",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                }}
                              >
                                {t("NUMBER OF")}
                              </p>
                              {/* <p style={{ fontWeight: 'bold', marginTop: 0, marginBottom: '1.5px' }}>OF</p> */}
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "13.5px",
                                }}
                              >
                                {t("PAYMENTS")}
                              </p>
                              <p
                                style={{
                                  marginTop: "0",
                                  marginBottom: "1.5px",
                                }}
                              >
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {validateData(data) &&
                                  validateData(data.weeklyTerm)
                                    ? data.weeklyTerm
                                    : "-"}{" "}
                                </span>
                                &nbsp;
                              </p>
                            </td>
                            <td
                              style={{
                                borderRight: "2px solid #000",
                                borderTop: "2px solid #000",
                                padding: "8px 11px",
                                textAlign: "center",
                                verticalAlign: "top",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "1.5px",
                                }}
                              >
                                {t("RENTAL")}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  marginTop: 0,
                                  marginBottom: "13.5px",
                                }}
                              >
                                {t("PERIOD")}
                              </p>
                              <p
                                style={{
                                  marginTop: "0",
                                  marginBottom: "1.5px",
                                }}
                              >
                                <span style={{ fontWeight: "bold" }}>
                                  {validateData(data) &&
                                  validateData(data.weeklyTerm)
                                    ? data.weeklyTerm
                                    : "-"}{" "}
                                </span>
                                &nbsp;{t("Weeks")}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                        padding: "2px 123px",
                      }}
                    >
                      <div>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span style={{ paddingRight: "20px" }}>
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                      <p
                        style={{
                          fontWeight: "bold",
                          fontSize: "22px",
                          marginLeft: "20px",
                        }}
                      >
                        {t("MINIMUM RENTAL OBLIGATION:  1 Week")}
                      </p>
                    </div>
                    {/* <div style={{marginBottom:"600px"}}></div> */}
                  </div>
                </div>
              </div>
            );
          }
        } else if (
          decodestore?.state == "AZ" ||
          decodestore?.state == "TX" ||
          decodestore?.state == "FL"
        ) {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");

            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "16%",
                        paddingRight: "20px",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                        marginBottom: "30px",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                            <span
                              style={{
                                top: "0",
                                right: "0",
                                position: "absolute",
                              }}
                            >
                              *
                            </span>
                          </span>

                          <div style={{ marginTop: "20px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter
                                    .format(data.regularWeeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter
                                  .format(data.monthlyRate)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter
                                  .format(data.totalCost)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Total Cost")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter
                                    .format(data.weeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          ></span>
                          <span style={{ fontSize: "25px" }}></span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          ></span>
                          <span style={{ fontSize: "25px" }}></span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "55px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "35px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.cashPrice)
                              ? formatter
                                  .format(data.cashPrice)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Cash Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    {/* <div style={{marginBottom:"600px"}}></div> */}
                  </div>
                </div>
              </div>
            );
          }
        } else if (decodestore?.state == "IA") {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "15%",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          marginLeft: "37px",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "52px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                          </span>

                          <div>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter.format(data.regularWeeklyRate)
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "65px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter.format(data.monthlyRate)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ width: '100%', textAlign: 'center', marginTop: '20px', whiteSpace: 'nowrap', marginBottom: '30px' }}>

                    </div> */}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "65px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter.format(data.weeklyRate)
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div style={{ width: "110%" }}>
                        <div style={{ width: "50%", float: "left" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of Payments")}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            width: "50%",
                            float: "left",
                            textAlign: "center",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter.format(data.totalCost)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Total Cost")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "65px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.cashPrice)
                              ? formatter.format(data.cashPrice)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Cash Price")}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            ></span>
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ width: '100%', textAlign: 'center', marginTop: '20px', whiteSpace: 'nowrap', marginBottom: '30px' }}>

                    </div> */}
                    </div>
                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "10px",
                          whiteSpace: "nowrap",
                          marginBottom: "20px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "600px",
                        textAlign: "center",
                        float: "left",
                        fontSize: "larger",
                        height: "70px",
                        border: "1px solid #000",
                        marginLeft: "60px",
                      }}
                    >
                      <span>
                        {t(
                          "This is Consumer Rental Purchase Agreement. You will not own the property until the total cost is paid in full or you exercise your early purchase option as provided for by lowa law"
                        )}
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        marginTop: "10px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    {/* <div style={{ marginBottom: "600px" }}></div> */}
                  </div>
                </div>
              </div>
            );
          }
        } else if (decodestore?.state == "ME" || decodestore?.state == "NC") {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "15%",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          marginLeft: "37px",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "45px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                          </span>

                          <div>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter.format(data.regularWeeklyRate)
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "65px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter.format(data.monthlyRate)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Weekly Price */}
                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "65px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter.format(data.weeklyRate)
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div style={{ width: "110%" }}>
                        <div style={{ width: "50%", float: "left" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of Payments")}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            width: "50%",
                            float: "left",
                            textAlign: "center",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter.format(data.totalCost)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Total Cost")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "65px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.cashPrice)
                              ? formatter.format(data.cashPrice)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Cash Price")}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "10px",
                          whiteSpace: "nowrap",
                          marginBottom: "20px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "560px",
                        textAlign: "center",
                        float: "left",
                        fontSize: "larger",
                        height: "70px",
                        border: "1px solid #000",
                        marginLeft: "80px",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            paddingRight: "58px",
                            float: "left",
                          }}
                        >
                          {validateData(data) && validateData(data.weeklyRate)
                            ? formatter.format(data.weeklyRate)
                            : " - "}
                          <hr
                            style={{
                              border: "1px solid black",
                              width: "169px",
                            }}
                          ></hr>
                        </span>
                        <span
                          style={{
                            fontWeight: "bold",
                            float: "left",
                            paddingRight: "77px",
                          }}
                        >
                          {t("after")}
                        </span>
                        <span
                          style={{
                            fontWeight: "bold",
                            float: "left",
                            paddingRight: "40px",
                          }}
                        >
                          {validateData(data) && validateData(data.weeklyTerm)
                            ? formatter.format(data.weeklyTerm)
                            : " - "}{" "}
                          <hr
                            style={{
                              border: "1px solid black",
                              width: "100px",
                            }}
                          ></hr>
                        </span>
                        <span style={{ fontWeight: "bold", float: "left" }}>
                          {t("weeks")}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "xx-large",
                        fontWeight: "bold",
                        float: "left",
                      }}
                    >
                      {t("Purchase Option Amount")}
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        marginTop: "10px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    {/* <div style={{ marginBottom: "600px" }}></div> */}
                  </div>
                </div>
              </div>
            );
          }
        } else if (decodestore?.state == "PA" || decodestore?.state == "GA") {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");

            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "15%",
                        paddingRight: "20px",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                        marginBottom: "30px",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                            <span
                              style={{
                                top: "0",
                                right: "0",
                                position: "absolute",
                              }}
                            >
                              *
                            </span>
                          </span>

                          <div style={{ marginTop: "20px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter
                                    .format(data.regularWeeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter
                                  .format(data.monthlyRate)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter
                                  .format(data.totalCost)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Retail Value")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "58px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter
                                    .format(data.weeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "35px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "85px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "35px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter.format(data.totalCost)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Total Cost")}
                            </span>
                            <br />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.cashPrice)
                              ? formatter
                                  .format(data.cashPrice)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Cost of Lease Services")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    {/* <div style={{marginBottom:"600px"}}></div> */}
                  </div>
                </div>
              </div>
            );
          }
        } else if (decodestore?.state == "PR") {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "15%",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          marginLeft: "37px",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                            <span
                              style={{
                                top: "0",
                                right: "0",
                                position: "absolute",
                              }}
                            >
                              *
                            </span>
                          </span>

                          <div style={{ marginTop: "20px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter
                                    .format(data.regularWeeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter
                                  .format(data.monthlyRate)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "65px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter
                                    .format(data.weeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "10px",
                          whiteSpace: "nowrap",
                          marginBottom: "35px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "85px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "35px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter.format(data.totalCost)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Total Cost")}
                            </span>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "550px",
                        float: "left",
                        borderTop: "1px solid #000",
                        borderLeft: "1px solid #000",
                        borderRight: "1px solid #000",
                        marginLeft: "85px",
                      }}
                    >
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyTerm)
                                ? data.weeklyTerm
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "100px",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Semi-Monthly Price")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{ fontSize: "25px", paddingRight: "4px" }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyTerm)
                                ? data.weeklyTerm
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "100px",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Number of Payments")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{ fontSize: "25px", paddingRight: "4px" }}
                            >
                              {validateData(data) &&
                              validateData(data.totalCost)
                                ? formatter.format(data.totalCost)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "100px",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Total Cost")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "550px",
                        float: "left",
                        border: "1px solid #000",
                        marginLeft: "85px",
                      }}
                    >
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{ fontSize: "25px", paddingRight: "4px" }}
                            >
                              {validateData(data) &&
                              validateData(data.monthlyRate)
                                ? formatter.format(data.monthlyRate)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "100px",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Monthly Price")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{ fontSize: "25px", paddingRight: "4px" }}
                            >
                              {validateData(data) &&
                              validateData(data.monthlyTerm)
                                ? data.monthlyTerm
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "100px",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Number of Payments")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{ fontSize: "25px", paddingRight: "4px" }}
                            >
                              {validateData(data) &&
                              validateData(data.totalCost)
                                ? formatter.format(data.totalCost)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "100px",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("TotalCost")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        fontSize: "17px",
                        marginLeft: "-45px",
                        textAlign: "end",
                        paddingTop: "11px",
                      }}
                    >
                      {t("*SALES TAX EXTRA ON ALL PRICES")}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    {/* <div style={{marginBottom:"600px"}}></div> */}
                  </div>
                </div>
              </div>
            );
          }
        } else if (decodestore?.state == "VT") {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "8%",
                        marginTop: "16%",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "70px",
                          textAlign: "center",
                          marginLeft: "37px",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>
                    <div style={{ width: "100%", float: "left" }}>
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "20px",
                            whiteSpace: "nowrap",
                            marginBottom: "20px",
                          }}
                        >
                          <div
                            style={{
                              border: "1px solid black",
                              padding: "6%",
                              margin: "0% 20%",
                            }}
                          >
                            <span
                              style={{ fontSize: "larger", fontWeight: "bold" }}
                            >
                              {t("Regular")}
                            </span>
                            <br />
                            <span
                              style={{ fontSize: "larger", fontWeight: "bold" }}
                            >
                              {t("Weekly Price")}
                              <span
                                style={{
                                  top: "0",
                                  right: "0",
                                  position: "absolute",
                                }}
                              >
                                *
                              </span>
                            </span>

                            <div style={{ marginTop: "20px" }}>
                              <span
                                style={{
                                  fontSize: "25px",
                                  fontWeight: "bold",
                                  marginTop: "20px",
                                  paddingRight: "4px",
                                  borderBottom: "1px solid black",
                                }}
                              >
                                {validateData(data) &&
                                validateData(data.regularWeeklyRate)
                                  ? formatter
                                      .format(data.regularWeeklyRate)
                                      .replace(/^(\D+)/, "$1 ")
                                  : " - "}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "20px",
                            whiteSpace: "nowrap",
                            marginBottom: "48px",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <div style={{ paddingTop: "15px" }}>
                              <span
                                style={{
                                  fontSize: "xx-large",
                                  fontWeight: "bold",
                                  paddingRight: "4px",
                                }}
                              >
                                {validateData(data) &&
                                validateData(data.weeklyRate)
                                  ? formatter
                                      .format(data.weeklyRate)
                                      .replace(/^(\D+)/, "$1 ")
                                  : " - "}
                              </span>
                            </div>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Weekly Price*")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "33.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "41px",
                            whiteSpace: "nowrap",
                            marginBottom: "65px",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyTerm)
                                ? data.weeklyTerm
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Number of")}
                              </span>
                              <br />
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                }}
                              >
                                {t("Payments")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "32.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "10px",
                            whiteSpace: "nowrap",
                            marginBottom: "10px",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.cashPrice)
                                ? formatter.format(data.cashPrice)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Cash Price")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <span style={{ float: "left", margin: "20px 0px" }}>
                        +
                      </span>
                      <div style={{ float: "left", width: "32.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "10px",
                            whiteSpace: "nowrap",
                            marginBottom: "10px",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.cashPrice)
                                ? formatter.format(data.cashPrice)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Rent-To-Own Change")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <span style={{ float: "left", margin: "20px 0px" }}>
                        *
                      </span>
                      <div style={{ float: "left", width: "32.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "10px",
                            whiteSpace: "nowrap",
                            marginBottom: "10px",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.totalCost)
                                ? formatter.format(data.totalCost)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Total Cost of OwnerShip")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "10px",
                          whiteSpace: "nowrap",
                          marginBottom: "10px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingLeft: "250px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "96%",
                        float: "left",
                        borderTop: "1px solid #000",
                        borderLeft: "1px solid #000",
                        borderRight: "1px solid #000",
                        marginTop: "10px",
                        marginLeft: "20px",
                      }}
                    >
                      <div style={{ float: "left", width: "50%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%", margin: "5px 0px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.monthlyTerm)
                                ? formatter.format(data.monthlyRate)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Monthly Price")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ float: "left", width: "50%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%", margin: "5px 0px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyTerm)
                                ? data.weeklyTerm
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Number of Payments")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "96%",
                        float: "left",
                        border: "1px solid #000",
                        marginBottom: "10px",
                        marginLeft: "20px",
                      }}
                    >
                      <div style={{ float: "left", width: "32.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%", margin: "5px 0px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.cashPrice)
                                ? formatter.format(data.cashPrice)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Cash Price")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <span style={{ float: "left", margin: "20px 0px" }}>
                        +
                      </span>
                      <div style={{ float: "left", width: "32.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%", margin: "5px 0px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyTerm)
                                ? data.weeklyTerm
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Rent-To-Own Change")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <span style={{ float: "left", margin: "20px 0px" }}>
                        *
                      </span>
                      <div style={{ float: "left", width: "32.33%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div style={{ width: "100%", margin: "5px 0px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.totalCost)
                                ? formatter.format(data.totalCost)
                                : " - "}
                            </span>
                            <div>
                              <span
                                style={{
                                  fontSize: "larger",
                                  fontWeight: "bold",
                                  borderTop: "1px solid black",
                                }}
                              >
                                {t("Total Cost of Ownership")}
                              </span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        marginLeft: "15px",
                        padding: "5px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      <div
                        style={{
                          float: "left",
                          fontSize: "16px",
                          textAlign: "end",
                          paddingTop: "11px",
                          display: "flex",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            width: "20px",
                            height: "20px",
                          }}
                        ></div>
                        <div style={{ margin: "4px 10px", fontWeight: "bold" }}>
                          {t("All Items new")}
                        </div>
                      </div>
                      <div
                        style={{
                          width: "60%",
                          float: "left",
                          fontSize: "16px",
                          textAlign: "end",
                          paddingTop: "11px",
                          display: "flex",
                        }}
                      >
                        <CloseIcon
                          style={{
                            border: "1px solid black",
                            width: "20px",
                            height: "20px",
                          }}
                        />
                        <div style={{ margin: "4px 10px", fontWeight: "bold" }}>
                          {t(
                            "Some used items. See individual tags for details."
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        marginLeft: "15px",
                        marginBottom: "1px",
                      }}
                    >
                      <div style={{ textAlign: "left" }}>
                        <span style={{ fontSize: "14px" }}>
                          {t(
                            "Rent-to-own agreement. You will not own the merchandise until the total cost of ownership is paid in full or you"
                          )}
                        </span>
                        <br />
                        <span style={{ fontSize: "14px" }}>
                          {t("exercise your early purchase option")}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        } else if (decodestore?.state == "WV") {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "15%",
                        paddingRight: "20px",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                        marginBottom: "30px",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                            <span
                              style={{
                                top: "0",
                                right: "0",
                                position: "absolute",
                              }}
                            >
                              *
                            </span>
                          </span>

                          <div style={{ marginTop: "20px" }}>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter
                                    .format(data.regularWeeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter
                                  .format(data.monthlyRate)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter
                                  .format(data.totalCost)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Rental Value")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "58px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter
                                    .format(data.weeklyRate)
                                    .replace(/^(\D+)/, "$1 ")
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "35px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "85px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "35px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter.format(data.totalCost)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Total Cost of All Payments")}
                            </span>
                            <br />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.cashPrice)
                              ? formatter
                                  .format(data.cashPrice)
                                  .replace(/^(\D+)/, "$1 ")
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Rent-To-Own Charge")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    {/* <div style={{marginBottom:"600px"}}></div> */}
                  </div>
                </div>
              </div>
            );
          }
        } else if (
          ["CT", "HI", "MI", "NJ", "OH"].includes(decodestore?.state)
        ) {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "15%",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          marginLeft: "37px",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                          </span>

                          <div>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter.format(data.regularWeeklyRate)
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter.format(data.monthlyRate)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter.format(data.totalCost)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Total Cost")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter.format(data.weeklyRate)
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          ></span>
                          <span style={{ fontSize: "25px" }}></span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          ></span>
                          <span style={{ fontSize: "25px" }}></span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ float: "left", width: "33.33%" }}>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.cashPrice)
                              ? formatter.format(data.cashPrice)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Cash Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    <div style={{ marginBottom: "600px" }}></div>
                  </div>
                </div>
              </div>
            );
          }
        } else if (decodestore?.country == "MX") {
          if (value == data.packagePriceId.toString()) {
            // Determine the number of inventories
            const inventoryCount = data.inventoryDetails.length;
           

            if (inventoryCount === 1) {
              // Calculate total cost from the single inventory
               const totalCost = data.inventoryDetails.reduce(
                (acc: any, item: any) => {
                  return (
                    acc +
                    (validateData(item.weeklyRate)
                      ?(parseFloat(item.weeklyRate) +
                            parseFloat(
                              item.weeklyRateTaxAmount
                                ? item.weeklyRateTaxAmount
                                : "0"
                            )
                        )
                      : 0)
                  );
                },
                0
              );

              return (
                <div
                  style={{
                    margin: 0,
                    fontFamily: "Arial",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      margin: "0 auto",
                      padding: "30px",
                      marginTop: "200px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "80px",
                        fontSize: "50px",
                        fontWeight: 700,
                        textAlign: "right",
                        color: "#333",
                        marginTop: "40px",
                        marginRight: "10px",
                      }}
                    >
                      {Priceformatter.format(Math.ceil(regularRate))}
                    </div>
                    {/* Pricing breakdown section */}
                    <div
                      style={{
                        marginBottom: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* Single Inventory Item */}
                      {data.inventoryDetails.map((item: any, index: any) => (
                        <div
                          key={index}
                          style={{ textAlign: "center", marginRight: "10px" }}
                        >
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              fontWeight: "bold",
                              marginBottom: "3px",
                            }}
                          >
                            {validateData(item.subDepartment)
                              ? item.subDepartment
                              : "-"}
                          </div>
                          <div
                            style={{
                              fontSize: "10px",
                              color: "#999",
                              marginBottom: "8px",
                            }}
                          >
                            {validateData(item.modelNumber)
                              ? item.modelNumber
                              : "-"}
                          </div>
                          <div
                            style={{
                              fontSize: "48px",
                              fontWeight: 700,
                              color: "#333",
                              lineHeight: 0.9,
                              marginBottom: "3px",
                            }}
                          >
                            <span style={{ fontSize: "24px" }}>$</span>
                            {Priceformatter.format(
                              Math.ceil(
                                parseFloat(item.weeklyRate) +
                                  parseFloat(item.weeklyRateTaxAmount)
                              )
                            )}
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              fontWeight: "bold",
                              marginBottom: "2px",
                            }}
                          >
                            SEMANALES
                          </div>
                          <div
                            style={{
                              fontSize: "9px",
                              color: "#999",
                              textAlign: "center",
                              lineHeight: 1.2,
                            }}
                          >
                            en un plazo de hasta{" "}
                            {validateData(item.monthlyTerm)
                              ? Math.round(Number(item.monthlyTerm))
                              : "-"}{" "}
                            meses
                          </div>
                        </div>
                      ))}
                      {/* Equal Sign */}
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#333",
                          margin: "0 12px",
                        }}
                      >
                        =
                      </div>
                      {/* Total Amount Displayed in the Same Line */}
                      <div style={{ textAlign: "center", marginLeft: "10px" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            fontWeight: "bold",
                            marginBottom: "3px",
                          }}
                        >
                          TOTAL
                        </div>
                        <div
                          style={{
                            fontSize: "38px",
                            fontWeight: 700,
                            color: "#333",
                            lineHeight: 0.9,
                            marginBottom: "3px",
                          }}
                        >
                          <span style={{ fontSize: "24px" }}>$</span>{" "}
                          {/* Dollar sign with smaller font size */}
                          {Priceformatter.format(Math.ceil(totalCost))}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginLeft: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          SEMANALES
                        </div>
                      </div>
                    </div>

                    <div style={{ textAlign: "center", position: "relative" }}>
                      {/* EN PAQUETE header */}
                      <div
                        style={{
                          padding: "12px 0",
                          marginBottom: "25px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          {/* Left Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginRight: "5px",
                            }}
                          ></div>

                          {/* Text Container */}
                          <div
                            style={{
                              display: "inline",
                              fontSize: "32px",
                              fontWeight: "800",
                              backgroundColor: "#fff",
                              color: "#333",
                              letterSpacing: "3px",
                              padding: "2px 20px",
                              position: "relative",
                            }}
                          >
                            EN PAQUETE
                          </div>

                          {/* Right Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginLeft: "5px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            width: "100%",
                            height: "3px",
                            backgroundColor: "#333",
                            zIndex: -2,
                          }}
                        ></div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Price section */}
                        <div style={{ flex: 2, textAlign: "center" }}>
                          <div
                            style={{
                              fontSize: "100px",
                              fontWeight: 700,
                              color: "#333",
                              lineHeight: 0.8,
                              marginBottom: "15px",
                            }}
                          >
                            <span style={{ fontSize: "60px" }}>$</span>
                            {Priceformatter.format(
                              Math.ceil(
                                parseFloat(data?.weeklyRate) +
                                  parseFloat(data.weeklyRateTaxAmount)
                              )
                            )}{" "}
                            {/* Replace with actual package price */}
                          </div>
                          <div
                            style={{
                              fontSize: "24px",
                              fontWeight: 700,
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            SEMANALES
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              lineHeight: 1.3,
                              fontWeight: "bold",
                            }}
                          >
                            en un plazo de hasta
                            <br />
                            {validateData(data.monthlyTerm)
                              ? Math.round(data.monthlyTerm)
                              : "-"}{" "}
                            meses
                          </div>
                        </div>

                        {/* QR Code section */}
                        <div
                          style={{
                            position: "absolute",
                            right: "50px",
                            flex: "1",
                            textAlign: "left",
                            marginTop: "10px",
                            marginRight: "10px",
                          }}
                        >
                          {" "}
                          {/* Added marginTop here */}
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                              lineHeight: "1.3",
                            }}
                          >
                            Escanea el QR
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              marginBottom: "5px",
                              fontWeight: "bold",
                            }}
                          >
                            para iniciar tu
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                            }}
                          >
                            proceso:
                          </div>
                          {/* QR Code pattern */}
                          <div
                            style={{
                              flexShrink: "0",
                              marginRight: "15px",
                              marginTop: "15px",
                            }}
                          >
                            <div
                              style={{
                                transform: "scale(1.2)",
                                transformOrigin: "top left",
                              }}
                            >
                              <QRCode
                                style={{ width: "90px", color: "#000" }}
                                aria-label="QR Code"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else if (inventoryCount === 2) {
              // Calculate total cost from all inventories
               const totalCost = data.inventoryDetails.reduce(
                (acc: any, item: any) => {
                  return (
                    acc +
                    (validateData(item.weeklyRate)
                      ?(parseFloat(item.weeklyRate) +
                            parseFloat(
                              item.weeklyRateTaxAmount
                                ? item.weeklyRateTaxAmount
                                : "0"
                            )
                        )
                      : 0)
                  );
                },
                0
              );

              return (
                <div
                  style={{
                    margin: 0,
                    fontFamily: "Arial",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      margin: "0 auto",
                      padding: "30px",
                      marginTop: "200px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "80px",
                        fontSize: "80px",
                        fontWeight: 700,
                        textAlign: "right",
                        color: "#333",
                        marginRight: "70px",
                        marginTop: "40px",
                      }}
                    >
                      {Math.ceil(regularRate)}
                    </div>
                    {/* Pricing breakdown section */}
                    <div
                      style={{
                        marginBottom: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* Inventory Items with "+" in between */}
                      {data.inventoryDetails.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <div
                            style={{ textAlign: "center", marginRight: "10px" }}
                          >
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                                marginBottom: "3px",
                              }}
                            >
                              {validateData(item.subDepartment)
                                ? item.subDepartment
                                : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "10px",
                                color: "#999",
                                marginBottom: "8px",
                              }}
                            >
                              {validateData(item.modelNumber)
                                ? item.modelNumber
                                : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "40px",
                                fontWeight: 700,
                                color: "#333",
                                lineHeight: 0.9,
                                marginBottom: "3px",
                              }}
                            >
                              <span style={{ fontSize: "24px" }}>$</span>{" "}
                              {/* Dollar sign with smaller font size */}
                              {Priceformatter.format(
                                Math.ceil(
                                  parseFloat(item.weeklyRate) +
                                    parseFloat(item.weeklyRateTaxAmount)
                                )
                              )}
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                                marginBottom: "2px",
                              }}
                            >
                              SEMANALES
                            </div>
                            <div
                              style={{
                                fontSize: "9px",
                                color: "#999",
                                textAlign: "center",
                                lineHeight: 1.2,
                              }}
                            >
                              en un plazo de hasta{" "}
                              {Math.round(Number(item.monthlyTerm))} meses
                            </div>
                          </div>
                          {/* Add "+" symbol between items except after the last item */}
                          {index < data.inventoryDetails.length - 1 && (
                            <div
                              style={{
                                fontSize: "36px",
                                fontWeight: "bold",
                                color: "#333",
                                margin: "0 10px",
                              }}
                            >
                              +
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                      {/* Equal Sign */}
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#333",
                          margin: "0 12px",
                        }}
                      >
                        =
                      </div>
                      {/* Total Amount Displayed in the Same Line */}
                      <div style={{ textAlign: "center", marginLeft: "10px" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            fontWeight: "bold",
                            marginBottom: "3px",
                          }}
                        >
                          TOTAL
                        </div>
                        <div
                          style={{
                            fontSize: "38px",
                            fontWeight: 700,
                            color: "#333",
                            lineHeight: 0.9,
                            marginBottom: "3px",
                          }}
                        >
                          <span style={{ fontSize: "24px" }}>$</span>{" "}
                          {/* Dollar sign with smaller font size */}
                          {Priceformatter.format(Math.ceil(totalCost))}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginLeft: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          SEMANALES
                        </div>
                      </div>
                    </div>

                    <div style={{ textAlign: "center", position: "relative" }}>
                      {/* EN PAQUETE header */}
                      <div
                        style={{
                          padding: "12px 0",
                          marginBottom: "25px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          {/* Left Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginRight: "5px",
                            }}
                          ></div>

                          {/* Text Container */}
                          <div
                            style={{
                              display: "inline",
                              fontSize: "32px",
                              fontWeight: "800",
                              backgroundColor: "#fff",
                              color: "#333",
                              letterSpacing: "3px",
                              padding: "2px 20px",
                              position: "relative",
                            }}
                          >
                            EN PAQUETE
                          </div>

                          {/* Right Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginLeft: "5px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            width: "100%",
                            height: "3px",
                            backgroundColor: "#333",
                            zIndex: -2,
                          }}
                        ></div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Price section */}
                        <div style={{ flex: 2, textAlign: "center" }}>
                          <div
                            style={{
                              fontSize: "100px",
                              fontWeight: 700,
                              color: "#333",
                              lineHeight: 0.8,
                              marginBottom: "15px",
                            }}
                          >
                            <span style={{ fontSize: "60px" }}>$</span>{" "}
                            {/* Dollar sign with smaller font size */}
                            {Priceformatter.format(
                              Math.ceil(
                                parseFloat(data?.weeklyRate) +
                                  parseFloat(data?.weeklyRateTaxAmount)
                              )
                            )}{" "}
                            {/* Replace with actual package price */}
                          </div>
                          <div
                            style={{
                              fontSize: "24px",
                              fontWeight: 700,
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            SEMANALES
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              lineHeight: 1.3,
                              fontWeight: "bold",
                            }}
                          >
                            en un plazo de hasta
                            <br />
                            {validateData(data?.monthlyTerm)
                              ? Math.round(data?.monthlyTerm)
                              : "-"}{" "}
                            meses
                          </div>
                        </div>

                        {/* QR Code section */}
                        <div
                          style={{
                            position: "absolute",
                            right: "50px",
                            flex: "1",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            Escanea el QR
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            para iniciar tu
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            proceso:
                          </div>
                          {/* QR Code pattern */}
                          <div
                            style={{
                              flexShrink: "0",
                              marginRight: "60px",
                              marginTop: "15px",
                            }}
                          >
                            <div
                              style={{
                                transform: "scale(1.2)",
                                transformOrigin: "top left",
                              }}
                            >
                              <QRCode
                                style={{ width: "90px", color: "#000" }}
                                aria-label="QR Code"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else if (inventoryCount === 3) {
              // Calculate total cost from all inventories
               const totalCost = data.inventoryDetails.reduce(
                (acc: any, item: any) => {
                  return (
                    acc +
                    (validateData(item.weeklyRate)
                      ?(parseFloat(item.weeklyRate) +
                            parseFloat(
                              item.weeklyRateTaxAmount
                                ? item.weeklyRateTaxAmount
                                : "0"
                            )
                        )
                      : 0)
                  );
                },
                0
              );

              return (
                <div
                  style={{
                    margin: 0,
                    fontFamily: "Arial",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      margin: "0 auto",
                      padding: "30px",
                      marginTop: "200px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "93px",
                        fontSize: "80px",
                        fontWeight: 700,
                        textAlign: "right",
                        color: "#333",
                        marginRight: "30px",
                        marginTop: "45px",
                      }}
                    >
                      {Math.ceil(regularRate)}
                    </div>

                    {/* Pricing breakdown section */}
                    <div
                      style={{
                        marginBottom: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* Inventory Items with "+" in between */}
                      {data.inventoryDetails.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <div
                            style={{ textAlign: "center", marginRight: "10px" }}
                          >
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                                marginBottom: "3px",
                              }}
                            >
                              {validateData(item.subDepartment)
                                ? item.subDepartment
                                : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "10px",
                                color: "#999",
                                marginBottom: "8px",
                              }}
                            >
                              {validateData(item.modelNumber)
                                ? item.modelNumber
                                : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: 700,
                                color: "#333",
                                lineHeight: 0.9,
                                marginBottom: "3px",
                              }}
                            >
                              <span style={{ fontSize: "24px" }}>$</span>{" "}
                              {/* Dollar sign with smaller font size */}
                              {Priceformatter.format(
                                Math.ceil(
                                  parseFloat(item?.weeklyRate) +
                                    parseFloat(item?.weeklyRateTaxAmount)
                                )
                              )}
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                                marginBottom: "2px",
                              }}
                            >
                              SEMANALES
                            </div>
                            <div
                              style={{
                                fontSize: "9px",
                                color: "#999",
                                textAlign: "center",
                                lineHeight: 1.2,
                              }}
                            >
                              en un plazo de hasta{" "}
                              {Math.round(Number(item?.monthlyTerm))} meses
                            </div>{" "}
                            {/* Updated to use Math.floor */}
                          </div>
                          {/* Add "+" symbol between items except after the last item */}
                          {index < data.inventoryDetails.length - 1 && (
                            <div
                              style={{
                                fontSize: "36px",
                                fontWeight: "bold",
                                color: "#333",
                                margin: "0 8px",
                              }}
                            >
                              +
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                      {/* Equal Sign */}
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#333",
                          margin: "0 10px",
                        }}
                      >
                        =
                      </div>
                      {/* Total Amount Displayed in the Same Line */}
                      <div style={{ textAlign: "center", marginLeft: "10px" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            fontWeight: "bold",
                            marginBottom: "3px",
                          }}
                        >
                          TOTAL
                        </div>
                        <div
                          style={{
                            fontSize: "40px",
                            fontWeight: 700,
                            color: "#333",
                            lineHeight: 0.9,
                            marginBottom: "3px",
                          }}
                        >
                          <span style={{ fontSize: "24px" }}>$</span>
                          {/* Dollar sign with smaller font size */}
                          {Priceformatter.format(Math.ceil(totalCost))}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginLeft: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          SEMANALES
                        </div>
                      </div>
                    </div>

                    <div style={{ textAlign: "center", position: "relative" }}>
                      {/* EN PAQUETE header */}
                      <div
                        style={{
                          padding: "12px 0",
                          marginBottom: "20px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            marginBottom: "20px",
                          }}
                        >
                          {/* Left Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginRight: "5px",
                            }}
                          ></div>

                          {/* Text Container */}
                          <div
                            style={{
                              display: "inline",
                              fontSize: "32px",
                              fontWeight: "800",
                              backgroundColor: "#fff",
                              color: "#333",
                              letterSpacing: "3px",
                              padding: "2px 20px",
                              position: "relative",
                            }}
                          >
                            EN PAQUETE
                          </div>

                          {/* Right Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginLeft: "5px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "50%",
                            width: "100%",
                            height: "3px",
                            backgroundColor: "#333",
                            zIndex: "-2",
                          }}
                        ></div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Price section */}
                        <div style={{ flex: 2, textAlign: "center" }}>
                          <div
                            style={{
                              fontSize: "100px",
                              fontWeight: 700,
                              color: "#333",
                              lineHeight: 0.8,
                              marginBottom: "15px",
                            }}
                          >
                            <span style={{ fontSize: "60px" }}>$</span>{" "}
                            {/* Dollar sign with smaller font size */}
                            {Priceformatter.format(
                              Math.ceil(
                                parseFloat(data?.weeklyRate) +
                                  parseFloat(data?.weeklyRateTaxAmount)
                              )
                            )}{" "}
                            {/* Replace with actual package price */}
                          </div>
                          <div
                            style={{
                              fontSize: "24px",
                              fontWeight: 700,
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            SEMANALES
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              lineHeight: 1.3,
                              fontWeight: "bold",
                            }}
                          >
                            en un plazo de hasta
                            <br />
                            {validateData(data.monthlyTerm)
                              ? Math.round(data.monthlyTerm)
                              : "-"}{" "}
                            meses {/* Updated to use Math.floor */}
                          </div>
                        </div>

                        {/* QR Code section */}
                        <div
                          style={{
                            position: "absolute",
                            right: "50px",
                            flex: "1",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            Escanea el QR
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            para iniciar tu
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            proceso:
                          </div>
                          {/* QR Code pattern */}
                          <div
                            style={{
                              flexShrink: "0",
                              marginRight: "60px",
                              marginTop: "15px",
                            }}
                          >
                            <div
                              style={{
                                transform: "scale(1.2)",
                                transformOrigin: "top left",
                              }}
                            >
                              <QRCode
                                style={{ width: "90px", color: "#000" }}
                                aria-label="QR Code"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else if (inventoryCount === 4) {
              // Calculate total cost from all inventories
               const totalCost = data.inventoryDetails.reduce(
                (acc: any, item: any) => {
                  return (
                    acc +
                    (validateData(item.weeklyRate)
                      ?(parseFloat(item.weeklyRate) +
                            parseFloat(
                              item.weeklyRateTaxAmount
                                ? item.weeklyRateTaxAmount
                                : "0"
                            )
                        )
                      : 0)
                  );
                },
                0
              );

              return (
                <div
                  style={{
                    margin: 0,
                    fontFamily: "Arial",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      margin: "0 auto",
                      padding: "30px",
                      marginTop: "200px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "40px",
                        fontSize: "80px",
                        fontWeight: 700,
                        textAlign: "right",
                        color: "#333",
                        marginRight: "70px",
                        marginTop: "20px",
                      }}
                    >
                      {Math.ceil(regularRate)}
                    </div>

                    {/* Pricing breakdown section */}
                    <div
                      style={{
                        marginBottom: "40px",
                        display: "flex",
                        marginTop: "30px",
                      }}
                    >
                      {/* Left Half for Inventory Items */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginLeft: "150px",
                        }}
                      >
                        {/* First Row */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: "2px",
                            marginRight: "20px",
                          }}
                        >
                          {data.inventoryDetails
                            .slice(0, 2)
                            .map((item: any, index: any) => (
                              <React.Fragment key={index}>
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginRight: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {validateData(item.subDepartment)
                                      ? item.subDepartment
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      color: "#999",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {validateData(item.modelNumber)
                                      ? item.modelNumber
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: 700,
                                      color: "#333",
                                      lineHeight: 0.9,
                                      marginBottom: "3px",
                                    }}
                                  >
                                    <span style={{ fontSize: "24px" }}>$</span>{" "}
                                    {/* Dollar sign with smaller font size */}
                                    <span style={{ fontSize: "36px" }}>
                                      {Math.ceil(
                                        parseFloat(item.weeklyRate) +
                                          parseFloat(item.weeklyRateTaxAmount)
                                      )}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    SEMANALES
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "9px",
                                      color: "#999",
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    en un plazo de hasta{" "}
                                    {Math.round(Number(item?.monthlyTerm))}{" "}
                                    meses
                                  </div>
                                </div>
                              </React.Fragment>
                            ))}
                        </div>

                        {/* Plus Symbol Centered Below the First Row */}
                        <div
                          style={{ textAlign: "center", marginBottom: "5px" }}
                        >
                          <div
                            style={{
                              fontSize: "36px",
                              fontWeight: "bold",
                              color: "#333",
                            }}
                          >
                            +
                          </div>
                        </div>

                        {/* Second Row */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "20px",
                          }}
                        >
                          {data.inventoryDetails
                            .slice(2, 4)
                            .map((item: any, index: any) => (
                              <React.Fragment key={index}>
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginRight: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {validateData(item.subDepartment)
                                      ? item.subDepartment
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      color: "#999",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {validateData(item.modelNumber)
                                      ? item.modelNumber
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: 700,
                                      color: "#333",
                                      lineHeight: 0.9,
                                      marginBottom: "3px",
                                    }}
                                  >
                                    <span style={{ fontSize: "24px" }}>$</span>{" "}
                                    {/* Dollar sign with smaller font size */}
                                    <span style={{ fontSize: "36px" }}>
                                      {Priceformatter.format(
                                        Math.ceil(
                                          parseFloat(item.weeklyRate) +
                                            parseFloat(item.weeklyRateTaxAmount)
                                        )
                                      )}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    SEMANALES
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "9px",
                                      color: "#999",
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    en un plazo de hasta{" "}
                                    {Math.round(Number(item?.monthlyTerm))}{" "}
                                    meses
                                  </div>
                                </div>
                              </React.Fragment>
                            ))}
                        </div>
                      </div>

                      {/* Right Half for Total Amount */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: "10px",
                          marginRight: "50px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              fontSize: "36px",
                              fontWeight: "bold",
                              color: "#333",
                              marginRight: "10px",
                            }}
                          >
                            =
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                                marginBottom: "3px",
                              }}
                            >
                              TOTAL
                            </div>
                            <div
                              style={{
                                fontSize: "35px",
                                fontWeight: 700,
                                color: "#333",
                                lineHeight: 0.9,
                                marginBottom: "3px",
                              }}
                            >
                              <span style={{ fontSize: "36px" }}>$</span>{" "}
                              {/* Dollar sign with smaller font size */}
                              <span style={{ fontSize: "48px" }}>
                                {Priceformatter.format(Math.ceil(totalCost))}
                              </span>
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                marginLeft: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              SEMANALES
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Package deal section */}
                    <div style={{ textAlign: "center", position: "relative" }}>
                      {/* EN PAQUETE header */}
                      <div
                        style={{
                          padding: "12px 0",
                          marginBottom: "5px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          {/* Left Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginRight: "5px",
                            }}
                          ></div>

                          {/* Text Container */}
                          <div
                            style={{
                              display: "inline",
                              fontSize: "32px",
                              fontWeight: "800",
                              backgroundColor: "#fff",
                              color: "#333",
                              letterSpacing: "3px",
                              padding: "2px 20px",
                              position: "relative",
                            }}
                          >
                            EN PAQUETE
                          </div>

                          {/* Right Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginLeft: "5px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "50%",
                            width: "100%",
                            height: "3px",
                            backgroundColor: "#333",
                            zIndex: "-2",
                          }}
                        ></div>
                      </div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        {/* Price section */}
                        <div style={{ flex: "2", textAlign: "center" }}>
                          <div
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                              color: "#333",
                              lineHeight: "0.8",
                              marginBottom: "5px",
                            }}
                          >
                            <span style={{ fontSize: "50px" }}>$</span>{" "}
                            {/* Dollar sign with smaller font size */}
                            <span style={{ fontSize: "100px" }}>
                              {Priceformatter.format(
                                Math.ceil(
                                  Number(data?.weeklyRate) +
                                    Number(data?.weeklyRateTaxAmount)
                                )
                              )}
                            </span>{" "}
                            {/* Replace with actual package price */}
                          </div>
                          <div
                            style={{
                              fontSize: "24px",
                              fontWeight: "700",
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            SEMANALES
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              lineHeight: 1.3,
                              fontWeight: "bold",
                            }}
                          >
                            en un plazo de hasta
                            <br />
                            {validateData(data?.monthlyTerm)
                              ? Math.round(data?.monthlyTerm)
                              : "-"}{" "}
                            meses
                          </div>
                        </div>

                        {/* QR Code section */}
                        <div
                          style={{
                            position: "absolute",
                            right: "50px",
                            flex: "1",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            Escanea el QR
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            para iniciar tu
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            proceso:
                          </div>
                          {/* QR Code pattern */}
                          <div
                            style={{
                              flexShrink: "0",
                              marginRight: "60px",
                              marginTop: "15px",
                            }}
                          >
                            <div
                              style={{
                                transform: "scale(1.2)",
                                transformOrigin: "top left",
                              }}
                            >
                              <QRCode
                                style={{ width: "90px", color: "#000" }}
                                aria-label="QR Code"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else if (inventoryCount === 5) {
              // Calculate total cost from all inventories
               const totalCost = data.inventoryDetails.reduce(
                (acc: any, item: any) => {
                  return (
                    acc +
                    (validateData(item.weeklyRate)
                      ?(parseFloat(item.weeklyRate) +
                            parseFloat(
                              item.weeklyRateTaxAmount
                                ? item.weeklyRateTaxAmount
                                : "0"
                            )
                        )
                      : 0)
                  );
                },
                0
              );

              return (
                <div
                  style={{
                    margin: 0,
                    fontFamily: "Arial",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      margin: "0 auto",
                      padding: "30px",
                      marginTop: "200px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "40px",
                        fontSize: "80px",
                        fontWeight: 700,
                        textAlign: "right",
                        color: "#333",
                        marginRight: "30px",
                        marginTop: "20px",
                      }}
                    >
                      {Math.ceil(regularRate)}
                    </div>

                    {/* Pricing breakdown section */}
                    <div
                      style={{
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Left Half for Inventory Items */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {/* First Row with 2 Inventory Items and '+' symbol in between */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            marginBottom: "10px",
                            marginLeft: "125px",
                          }}
                        >
                          {data.inventoryDetails
                            .slice(0, 2)
                            .map((item: any, index: any) => (
                              <React.Fragment key={index}>
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginRight: index === 0 ? "10px" : "0",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {validateData(item.subDepartment)
                                      ? item.subDepartment
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      color: "#999",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {validateData(item.modelNumber)
                                      ? item.modelNumber
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "36px",
                                      fontWeight: 700,
                                      color: "#333",
                                      lineHeight: 0.9,
                                      marginBottom: "3px",
                                    }}
                                  >
                                    <span style={{ fontSize: "24px" }}>$</span>{" "}
                                    {/* Dollar sign with smaller font size */}
                                    {Priceformatter.format(
                                      Math.ceil(
                                        parseFloat(item?.weeklyRate) +
                                          parseFloat(item?.weeklyRateTaxAmount)
                                      )
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    SEMANALES
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "9px",
                                      color: "#999",
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    en un plazo de hasta{" "}
                                    {validateData(item.monthlyTerm)
                                      ? Math.round(Number(item.monthlyTerm))
                                      : "-"}{" "}
                                    meses
                                  </div>
                                </div>
                                {index === 0 && (
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      color: "#333",
                                      marginLeft: "10px",
                                      marginRight: "10px",
                                      marginTop: "40px",
                                    }}
                                  >
                                    +
                                  </span>
                                )}
                              </React.Fragment>
                            ))}
                        </div>

                        {/* Second Row with 3 Inventory Items and '+' symbols in between */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "center",
                          }}
                        >
                          {data.inventoryDetails
                            .slice(2, 5)
                            .map((item: any, index: any) => (
                              <React.Fragment key={index}>
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginRight: index < 2 ? "10px" : "0",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {validateData(item.subDepartment)
                                      ? item.subDepartment
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      color: "#999",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {validateData(item.modelNumber)
                                      ? item.modelNumber
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "36px",
                                      fontWeight: 700,
                                      color: "#333",
                                      lineHeight: 0.9,
                                      marginBottom: "3px",
                                    }}
                                  >
                                    <span style={{ fontSize: "24px" }}>$</span>{" "}
                                    {/* Dollar sign with smaller font size */}
                                    {Priceformatter.format(
                                      Math.ceil(
                                        parseFloat(item?.weeklyRate) +
                                          parseFloat(item?.weeklyRateTaxAmount)
                                      )
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "bold",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    SEMANALES
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "9px",
                                      color: "#999",
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    en un plazo de hasta{" "}
                                    {validateData(item.monthlyTerm)
                                      ? Math.round(Number(item.monthlyTerm))
                                      : "-"}{" "}
                                    meses
                                  </div>
                                </div>
                                {(index === 0 || index === 1) && (
                                  <span
                                    style={{
                                      fontSize: "24px",
                                      color: "#333",
                                      marginLeft: "10px",
                                      marginRight: "10px",
                                      marginTop: "40px",
                                    }}
                                  >
                                    +
                                  </span>
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                      </div>

                      {/* Right Half for Total Amount */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              fontSize: "36px",
                              fontWeight: "bold",
                              color: "#333",
                              marginRight: "10px",
                            }}
                          >
                            =
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "bold",
                                marginBottom: "3px",
                              }}
                            >
                              TOTAL
                            </div>
                            <div
                              style={{
                                fontSize: "48px",
                                fontWeight: 700,
                                color: "#333",
                                lineHeight: 0.9,
                                marginBottom: "3px",
                              }}
                            >
                              <span style={{ fontSize: "24px" }}>$</span>{" "}
                              {/* Dollar sign with smaller font size */}
                              {Priceformatter.format(Math.floor(totalCost))}
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                marginLeft: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              SEMANALES
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Package deal section */}
                    <div style={{ textAlign: "center", position: "relative" }}>
                      {/* EN PAQUETE header */}
                      <div
                        style={{
                          padding: "12px 0",
                          marginBottom: "10px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          {/* Left Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginRight: "5px",
                            }}
                          ></div>

                          {/* Text Container */}
                          <div
                            style={{
                              display: "inline",
                              fontSize: "32px",
                              fontWeight: "800",
                              backgroundColor: "#fff",
                              color: "#333",
                              letterSpacing: "3px",
                              padding: "2px 20px",
                              position: "relative",
                            }}
                          >
                            EN PAQUETE
                          </div>

                          {/* Right Line */}
                          <div
                            style={{
                              flex: 1,
                              height: "2px",
                              backgroundColor: "#333",
                              marginLeft: "5px",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "50%",
                            width: "100%",
                            height: "3px",
                            backgroundColor: "#333",
                            zIndex: "-2",
                          }}
                        ></div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Price section */}
                        <div style={{ flex: 2, textAlign: "center" }}>
                          <div
                            style={{
                              fontSize: "100px",
                              fontWeight: 700,
                              color: "#333",
                              lineHeight: 0.8,
                              marginBottom: "15px",
                            }}
                          >
                            <span style={{ fontSize: "60px" }}>$</span>{" "}
                            {/* Dollar sign with smaller font size */}
                            {Priceformatter.format(
                              Math.ceil(
                                parseFloat(data?.weeklyRate) +
                                  parseFloat(data?.weeklyRateTaxAmount)
                              )
                            )}{" "}
                            {/* Replace with actual package price */}
                          </div>
                          <div
                            style={{
                              fontSize: "24px",
                              fontWeight: 700,
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            SEMANALES
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              lineHeight: "1.3",
                              fontWeight: "bold",
                            }}
                          >
                            en un plazo de hasta
                            <br />
                            {validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : "-"}{" "}
                            meses
                          </div>
                        </div>

                        {/* QR Code section */}
                        <div
                          style={{
                            position: "absolute",
                            right: "50px",
                            flex: "1",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                              marginBottom: "5px",
                            }}
                          >
                            Escanea el QR
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                            }}
                          >
                            para iniciar tu
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: "bold",
                            }}
                          >
                            proceso:
                          </div>
                          {/* QR Code pattern */}
                          <div
                            style={{
                              flexShrink: "0",
                              marginRight: "15px",
                              marginTop: "15px",
                            }}
                          >
                            <div
                              style={{
                                transform: "scale(1.2)",
                                transformOrigin: "top left",
                              }}
                            >
                              <QRCode
                                style={{ width: "90px", color: "#000" }}
                                aria-label="QR Code"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          }
        } else {
          if (value == data.packagePriceId.toString()) {
            console.log("vvv");
            return (
              <div style={{ margin: "0px", fontFamily: "Arial" }}>
                <div style={{ margin: "0px", width: "100%", float: "left" }}>
                  <div
                    style={{
                      width: "100%",
                      fontFamily: "Arial",
                      margin: "0px auto 0px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "14%",
                        marginTop: "15%",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "80px",
                          textAlign: "center",
                          marginLeft: "37px",
                          display: "inline-block",
                        }}
                      >
                        {validateData(rateRegular) ? rateRegular : " - "}
                      </h1>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "bold",
                      }}
                    >
                      {data.inventoryDetails.map((details: any) => {
                        return (
                          <span style={{ fontSize: "20px" }}>
                            {validateData(details) &&
                            validateData(details.inventoryDesc)
                              ? details.inventoryDesc
                              : " - "}
                            <br />
                          </span>
                        );
                      })}
                    </div>

                    <div
                      style={{
                        float: "left",
                        width: "33.33%",
                        paddingTop: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid black",
                            padding: "6%",
                            margin: "0% 20%",
                          }}
                        >
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Regular")}
                          </span>
                          <br />
                          <span
                            style={{ fontSize: "larger", fontWeight: "100px" }}
                          >
                            {t("Weekly Price")}
                          </span>

                          <div>
                            <span
                              style={{
                                fontSize: "25px",
                                fontWeight: "bold",
                                marginTop: "20px",
                                paddingRight: "4px",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.regularWeeklyRate)
                                ? formatter.format(data.regularWeeklyRate)
                                : " - "}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyRate)
                              ? formatter.format(data.monthlyRate)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Monthly Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              paddingRight: "4px",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {validateData(data) && validateData(data.totalCost)
                              ? formatter.format(data.totalCost)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Total Cost")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        float: "left",
                        width: "33.33%",
                        paddingTop: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "xx-large",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {validateData(data) &&
                              validateData(data.weeklyRate)
                                ? formatter.format(data.weeklyRate)
                                : " - "}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: "xx-large",
                              fontWeight: "bold",
                              borderTop: "1px solid black",
                            }}
                          >
                            {t("Weekly Price*")}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          ></span>
                          <span style={{ fontSize: "25px" }}></span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          ></span>
                          <span style={{ fontSize: "25px" }}></span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          {validateData(data) &&
                          validateData(data.sacDaysToPrint) &&
                          Number(data.sacDaysToPrint) > 0 ? (
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                paddingRight: "4px",
                              }}
                            >
                              {data.sacDaysToPrint} {t("Days Same as Cash")}
                            </span>
                          ) : (
                            <span style={{ fontSize: "20px" }}></span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        float: "left",
                        width: "33.33%",
                        paddingTop: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              paddingRight: "4px",
                            }}
                          >
                            {validateData(data) && validateData(data.weeklyTerm)
                              ? data.weeklyTerm
                              : " - "}
                          </span>
                          <div style={{ paddingTop: "15px" }}>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) &&
                            validateData(data.monthlyTerm)
                              ? data.monthlyTerm
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Number of")}{" "}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                              }}
                            >
                              {t("Payments")}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          whiteSpace: "nowrap",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ width: "100%", paddingLeft: "4px" }}>
                          <span
                            style={{ fontSize: "25px", paddingRight: "4px" }}
                          >
                            {validateData(data) && validateData(data.cashPrice)
                              ? formatter.format(data.cashPrice)
                              : " - "}
                          </span>
                          <div>
                            <span
                              style={{
                                fontSize: "larger",
                                fontWeight: "100px",
                                borderTop: "1px solid black",
                              }}
                            >
                              {t("Cash Price")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        fontSize: "large",
                        marginBottom: "20px",
                        float: "left",
                      }}
                    >
                      <div style={{ paddingLeft: "54px" }}>
                        {validateData(data) &&
                        validateData(data.weeklyRateAddOn) &&
                        Number(data.weeklyRateAddOn) > 0 ? (
                          <span style={{ paddingRight: "5px" }}>
                            {data.weeklyRateAddOn} -&nbsp;
                          </span>
                        ) : (
                          ""
                        )}
                        {data.inventoryDetails.map((details: any) => {
                          return (
                            <span
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              {validateData(details) &&
                              validateData(details.inventoryNumber)
                                ? details.inventoryNumber
                                : " - "}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    <div style={{ marginBottom: "600px" }}></div>
                  </div>
                </div>
              </div>
            );
          }
        }
      });
    });
  };

  return <React.Fragment>{PrintPackagePrice()}</React.Fragment>;
}
